/**
 * User: daletan
 * Date: 6/23/14
 * Time: 10:44 AM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 *
 * formerly:
 * js/global/core/dibs.js#isMobile
 * js/global/core/dibs.js#isTouchDevice
 * dibs.isMobile
 * dibs.isTouchDevice
 */

'use strict';
var getUserAgent = function () { // eslint-disable-line no-var
    return window.navigator && window.navigator.userAgent;
};

/**
 * Detect if user is on mobile device
 * this is a jenky solution since it relies on the user agent
 * it should rely on feature detection instead
 */
module.exports = {
    Android: function (ua) {
        return (/Android/i).test(ua || getUserAgent());
    },
    BlackBerry: function (ua) {
        return (/BlackBerry/i).test(ua || getUserAgent());
    },
    BlackBerry10: function (ua) {
        return (/BB10/i).test(ua || getUserAgent());
    },
    iPhone: function (ua) {
        return (/iPhone/i).test(ua || getUserAgent());
    },
    iPad: function (ua) {
        return (/iPad/i).test(ua || getUserAgent());
    },
    iPod: function (ua) {
        return (/iPod/i).test(ua || getUserAgent());
    },
    iOS: function (ua) {
        return this.iPhone(ua) || this.iPad(ua) || this.iPod(ua);
    },
    Opera: function (ua) {
        return (/Opera Mobi/i).test(ua || getUserAgent());
    },
    Windows: function (ua) {
        return (/IEMobile/i).test(ua || getUserAgent());
    },
    iOSVersion: function (version, ua) {
        var r = new RegExp('(iPad|iPhone|iPod);.*CPU.*OS ' + version + '_\\d', 'i'); // eslint-disable-line no-var
        return r.test(ua || getUserAgent());
    },
    any: function (ua) {
        var isMobile = false; // eslint-disable-line no-var
        var blacklist = [ // eslint-disable-line no-var
            'hasTouch',
            'isTouchDevice',
            'any',
            'iOSVersion'
        ];
        var p; // eslint-disable-line no-var

        for (p in this) {
            if (this.hasOwnProperty(p) && blacklist.indexOf(p) === -1) {
                isMobile = this[p](ua || getUserAgent());
                if (isMobile) {
                    return isMobile;
                }
            }
        }
        return isMobile;
    },
    /**
     * @returns {boolean}
     */
    hasTouch: function () {
        // http://stackoverflow.com/a/4819886
        // reference  GFoley83 Sep 4 '13 at 6:20 comment
        //
        // added non-prefixed maxTouchPoints based on this post:
        // http://msdn.microsoft.com/en-us/library/ie/hh772144%28v=vs.85%29.aspx
        return (window.navigator && !!(window.navigator.msMaxTouchPoints) || !!(window.navigator.maxTouchPoints)) || 'ontouchstart' in window;
    }
};


//DETECT TOUCH CAPABILITIES



//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-client-check/dist/mobileCheck.js
// module id = ./node_modules/dibs-client-check/dist/mobileCheck.js
// module chunks = 4